module.exports = __webpack_public_path__ + "76aa9c6b2e2363390ca7aa204185045b.fbx";